import AppTable from './AppTable.vue'

export default AppTable
